<template>
  <div class="col-12 page_content_area">
    <div class="container">
      <div class="row justify-content-center login_content_area">
        <div class="col-7">
          <shadow-container>
            <div class="row justify-content-center">
              <div class="col-7">
                <div class="row">
                  <div class="col-12">
                    <form
                      class="lar_form"
                      @submit.prevent="letMeResetPassword"
                    >
                      <form-row>
                        <p class="text-center col-12">
                          請輸入新密碼
                        </p>
                      </form-row>
                      <form-row>
                        <form-group cols="12">
                          <input-group>
                            <template slot="prepend">
                              <span
                                aria-hidden="true"
                                class="input-group-text text-muted"
                              >
                                <font-awesome-icon icon="lock" />
                              </span>
                            </template>
                            <form-input
                              v-model="password"
                              type="password"
                              placeholder="新的密碼"
                              name="password"
                            />
                          </input-group>
                        </form-group>
                      </form-row>
                      <form-row>
                        <form-group cols="12">
                          <input-group>
                            <template slot="prepend">
                              <span
                                aria-hidden="true"
                                class="input-group-text text-muted"
                              >
                                <font-awesome-icon icon="lock" />
                              </span>
                            </template>
                            <form-input
                              v-model="password_confirmation"
                              type="password"
                              placeholder="確認密碼"
                              name="password-confirmation"
                            />
                          </input-group>
                        </form-group>
                      </form-row>
                      <form-row>
                        <button
                          class="btn--pill btn--fill pill--lg pill darken_blue"
                        >
                          重設密碼
                        </button>
                      </form-row>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </shadow-container>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ShadowContainer from '~components/common/ShadowContainer'
import FormRow from '~components/common/form/Row'
import FormGroup from '~components/common/form/Group'
import FormInput from '~components/common/form/input'
import InputGroup from '~components/common/form/input/Group'
export default {
  name: 'ResetPasswordContent',
  components: {
    ShadowContainer,
    FormRow,
    FormGroup,
    FormInput,
    InputGroup
  },
  data () {
    return {
      password: '',
      password_confirmation: ''
    }
  },
  methods: {
    letMeResetPassword () {
      this.$emit('submit', {
        password: this.password,
        password_confirmation: this.password_confirmation,
        token: this.$route.query.token
      })
    }
  }
}
</script>
